// frontend/src/pages/CadastroPage.jsx

import React from 'react';
import PatientForm from '../components/PatientForm';
import toast from 'react-hot-toast';
import api from '../services/api';

export default function CadastroPage() {
  
  // Esta função lida com a submissão, envolvendo a chamada da API em um toast.promise
  const handleCadastro = async (formData) => {
    const promise = api.post('/patients', formData);

    // NENHUMA MUDANÇA AQUI! A lógica de erro já é inteligente o suficiente.
    toast.promise(promise, {
      loading: 'Cadastrando paciente...',
      success: (res) => `Paciente "${res.data.data.nome}" cadastrado com sucesso!`,
      error: (err) => `Erro: ${err.response?.data?.error || 'Ocorreu um problema.'}`
    });

    try {
      await promise;
      return true; // Retorna sucesso para o componente do formulário
    } catch (error) {
      return false; // Retorna falha
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Título e Subtítulo */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Novo Paciente</h1>
          <p className="text-gray-500">Cadastre rapidamente um novo paciente no sistema</p>
        </div>

        {/* Card Central */}
        <div className="bg-white rounded-2xl shadow-lg p-8">
          {/* Passa a função de submissão para o componente do formulário */}
          <PatientForm onCadastroSubmit={handleCadastro} />
        </div>
      </div>
    </div>
  );
}
